export default __webpack_public_path__ + "static/media/societe-02.3c17f968.jpg";